import React, { useEffect } from 'react';
import AOS from "aos";
import "aos/dist/aos.css";
import StatCard from '../../Components/StatCard';
import founderStats from '../../data/AboutSectionData/founderStats';
import GreenRibbon from '../../Components/GreenRibbon';
import BlurText from '../../Components/Text/BlurText';
import stats from '../../data/LandingSectionData/stats';
import { useInView } from 'react-intersection-observer';


const AboutTechXplore = () => {


  useEffect(() => {
    AOS.init({
      duration: 1000
    });
  }, []);
  const [ref1, inView1] = useInView({ triggerOnce: true });
  const [ref2, inView2] = useInView({ triggerOnce: true });
  const [ref3, inView3] = useInView({ triggerOnce: true });
  const [ref4, inView4] = useInView({ triggerOnce: true });

  const refs = [ref1, ref2, ref3, ref4];
  const inViews = [inView1, inView2, inView3, inView4];

  return (
      <section className="relative bg-bgDefault text-white px-5 py-24 lg:px-16 lg:py-28 overflow-hidden">
      <GreenRibbon />

      <div className="relative container mx-auto xl:max-w-screen-xl z-10">
      <div className="grid grid-cols-1 lg:grid-cols-12 lg:gap-8 "  data-aos="fade-up"
     data-aos-anchor-placement="center-center">
        <div className="col-span-12 lg:col-span-7">
          <h2 className="text-heading-4 md:text-heading-1 font-dmsans font-bold tracking-[-0.06em] mb-6">
            About Us
          </h2>
          <p className=" lg:text-body text-body-sm text-[#9E9E9E] font-roboto lg:pr-32">
            At Techxplore, we build scalable, intelligent, and future-ready digital solutions for startups and enterprises. With expertise in AI, cloud, and software engineering, we transform complex ideas into reliable, high-performance products that drive innovation, accelerate growth, and create lasting business impact.
          </p>
        </div>

       
        <div className="col-span-12 lg:col-span-5">
        </div>
      </div>


       <div className="flex flex-col md:grid md:grid-cols-12  lg:grid-cols-12 lg:gap-x-8 lg:mt-56 mt-14">
          
          {/* 1. Founder Description */}
          <div className="md:col-span-7 lg:col-span-7  lg:px-1  md:px-6 md:pb-4 order-1 md:order-2 ">
          <BlurText
            text="Meet the Founder"
            delay={150}
            animateBy="words"
            direction="top"
            
            className="text-heading-4 md:text-heading-1 font-dmsans font-bold tracking-[-0.06em] mb-4"
          />
            <div className="md:pr-8">
              <p className="md:text-body text-body-sm text-[#9E9E9E] font-roboto mb-6">
                With over 11 years in the software industry, Vikas Rajput’s journey from a Java Fullstack Engineer to the founder of TechXplore IT Solutions reflects his passion for crafting impactful technology. Having led roles across development, architecture, and leadership, he now helps businesses scale through innovation. 
              </p>
              {/* <p className="md:text-body text-body-sm text-[#9E9E9E] font-roboto mb-8">
                Beyond work, Vikas actively shares his knowledge as a speaker at Java and tech conferences across India. To know more about his journey, visit his <a href="https://www.vikasrajput.in/about-me" target="_blank" rel="noopener noreferrer" className="text-green-500">personal website</a>.
              </p> */}
            </div>
            {/* <div className="hidden sm:grid grid-cols-2 md:grid-cols-3 gap-4 md:col-span-12 mt-6 md:mt-0 "> */}

              <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 gap-4 sm:gap-6 md:gap-8">
            {/* {founderStats.map((item, idx) => (
              <StatCard
                key={idx}
                value={item.value}
                suffix={item.suffix}
                label={item.label}
                inView={true}
                cardRef={null}
              />
            ))} */}

            {/* <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 gap-4 sm:gap-6 md:gap-8"> */}
          {stats.map((item, idx) => (
            <StatCard
              key={idx}
              value={item.value}
              suffix={item.suffix}
              label={item.label}
              inView={inViews[idx]}
              cardRef={refs[idx]}
            />
          ))}
        {/* </div> */}
          </div>
          </div>

          {/* 2. Founder Image */}
          <div className="md:col-span-5 order-2 md:order-1 mt-12 lg:mt-4" data-aos="fade-zoom-in"
              data-aos-easing="ease-in-back"
              data-aos-delay="300"
              data-aos-offset="0">
            <img
              src="/founder/Vikas-Rajput-Working.png"
              alt="Vikas Rajput"
              className="shadow-lg w-full"
            />
            <div className="text-center lg:mt-4">
              <p className="lg:text-[79px] leading-[86px] font-onesignature font-normal text-heading-2">Vikas Rajput</p>
              <p className="lg:text-heading-5 font-normal font-dmsans text-white">Founder at Techxplore</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutTechXplore;
